/**
 * The Capabilities entry point. Renders `summaryText` VERBATIM — it never
 * counts or partitions anything itself, so it cannot disagree with the popup.
 *
 * Not an aria-live region: the summary changes on load and would announce
 * every time.
 */
export default function CapabilitiesStrip({ derived, onOpen }) {
  const { summaryText } = derived;
  return (
    <button
      type="button"
      className="cap-strip"
      onClick={onOpen}
      aria-label="Open capabilities"
    >
      <span className="cap-strip-label">Capabilities</span>
      {summaryText && <span className="cap-strip-summary">{summaryText}</span>}
      <span className="cap-strip-arrow" aria-hidden="true">→</span>
    </button>
  );
}
